import styled, { css } from 'styled-components';

interface TypeSelectWrapperProps {
  $disabled: boolean;
  $searchable: boolean;
}

interface ControlWrapperProps extends TypeSelectWrapperProps {
  $expanded: boolean;
  $searchable: boolean;
}

type DropdownOptionProps = TypeSelectWrapperProps;

const getExpandedStyle = (expanded: boolean, theme) => {
  if (expanded) {
    return css`
      border-color: ${theme.palette.accents_5};
      border-bottom: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      transition: none;
      background-color: ${theme.palette.accents_1};
    `;
  }
  return null;
};

export const TypeSelectWrapper = styled('div')<TypeSelectWrapperProps>`
  position: relative;
  border-radius: 4px;
  opacity: ${({ $disabled }) => ($disabled ? '0.5' : '')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const ControlWrapper = styled('div')<ControlWrapperProps>`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.border};
  height: ${({ $searchable, $expanded }) => ($expanded && $searchable ? '110px' : '64px')};
  transition: all 0.3s ease-in-out;
  background-color: #fff;

  &:hover {
    border-color: ${({ $disabled, theme }) => ($disabled ? '' : theme.palette.accents_5)};
  }

  ${({ $expanded, theme }) => getExpandedStyle($expanded, theme)};
`;

export const DropdownArrow = styled.div`
  position: absolute;
  height: 16px;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  &:hover {
    background-color: ${({ theme }) => theme.palette.accents_1};
  }
  z-index: 999;
`;

export const DropdownWrapper = styled.div<{
  $searchable: boolean;
}>`
  position: absolute;
  top: ${({ $searchable }) => ($searchable ? '109px' : '63px')};
  left: 0px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.accents_5};
  border-radius: 4px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top: 0;
  background-color: ${({ theme }) => theme.palette.background};
  z-index: 9999;
  //box-sizing: content-box;
`;

export const DropdownOption = styled.div<DropdownOptionProps>`
  height: 64px;
  padding: 12px 64px 12px 12px;
  opacity: ${({ $disabled }) => ($disabled ? '0.5' : '')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : '')};

  &:hover {
    background-color: ${({ $disabled, theme }) => ($disabled ? '' : theme.palette.accents_0)};
  }
`;

export const InputWrapper = styled.div`
  padding: 6px;
  background: #fff;
  border-radius: 4px 4px 0 0;
`;

export const FieldWrapper = styled.div`
  padding: 12px 64px 12px 12px;
`;
